/* eslint-disable no-underscore-dangle */

const _ = require('lodash');
const CollectionAttribute = require('./../index');
const Range = require('./../../../NumericValues/Range');

function isNumericString(value) {
  return !_.isNaN(_.toNumber(value));
}

function equals(attributeValue, value) {
  let areEqual = false;
  if (!_.isNil(value)) {
    if (isNumericString(value) && isNumericString(attributeValue.value)) {
      areEqual = _.isEqual(_.toNumber(value), _.toNumber(attributeValue.value));
    } else if (value instanceof Range) {
      areEqual = value.isImpliable() && attributeValue.value.toLowerCase() === value.minimum.toLowerCase();
    } else {
      areEqual = attributeValue.value.toLowerCase() === value.toLowerCase();
    }
  }

  return areEqual;
}

function hasDuplicateValues(config) {
  let hasDuplicates = false;
  const dictionary = {};
  _.each(config.attributeValues, (value) => {
    if (_.isNil(dictionary[value.value.toLowerCase()])) {
      dictionary[value.value.toLowerCase()] = true;
    } else {
      hasDuplicates = true;
    }
  });

  return hasDuplicates;
}

function validate(config) {
  if (_.isNil(config)) {
    throw new Error('config must not be null or undefined.');
  }

  if (_.isEmpty(config.attributeValues)) {
    throw new Error('attributeValues are required');
  }

  if (hasDuplicateValues(config)) {
    throw new Error(`Attribute ${config.key} has duplicate values.`);
  }

  return true;
}

module.exports = class AttributeConstraintValues extends CollectionAttribute {
  /**
   * See parent for details.
   * @param  {Object[]} config.attributeValues A collection of attributeValues that are valid for this attribute.
   */
  constructor(config) {
    validate(config);
    super(config);

    this._attributeValues = config.attributeValues;
    this._type = CollectionAttribute.Types.listOfValues;
  }

  /**
   * Does the given value overlap with this attribute's values
   * @param  {string|Range} value The value to check against
   * @return {bool} true if and only if the given value doesn't overlap with this attribute's values
   */
  overlaps(value) {
    return _.some(this._attributeValues, (attributeValue) => {
      if (value instanceof Range) {
        return value.contains(attributeValue.value);
      }

      return equals(attributeValue, value);
    });
  }

  /**
   * Does this attribute contain the given value
   * @param {string|Range} value The value to check against
   * @return {bool} true if and only if the given value is contained by this attribute's values
   */
  contains(value) {
    return _.some(this._attributeValues, attributeValue => equals(attributeValue, value));
  }

  /**
   * See parent for details.
   */
  canBeImplied() {
    return this.validOptions.length === 1;
  }

  get values() {
    return this._attributeValues;
  }

  get validOptions() {
    return _.map(this._attributeValues, attributeValue => attributeValue.value);
  }
};
